import classNames from 'classnames';
import Image from 'next/image';

import { Video } from '@/ui/index';
import { ArrowRight, PlayEmpty } from '@/icons/index';
import SliderWrapper from '@/ui/SliderWrapper/SliderWrapper';

import styles from './ChooseTopic.module.scss';

const SlickArrow = ({ onClick, className }) => {
  return (
    <span
      className={className}
      onClick={onClick}
      itemScope
      itemType='https://schema.org/NavigationElement'
    >
      <span className={styles.arrowBlock}>
        <ArrowRight />
      </span>
    </span>
  );
};

export const Step = ({ step }) => {
  return (
    <div
      className={styles.step}
      itemScope
      itemType='https://schema.org/HowToStep'
    >
      <div className={styles.title}>{step.title}</div>
      <div className={styles.image}>
        <Image
          src={step.img}
          alt={step.title}
          title={step.title}
          loading='lazy'
          layout='fill'
        />
      </div>
    </div>
  );
};

const ContentBlock = ({ data: { title: name = '', videos }, dark = false }) => {
  return (
    <div
      className={styles.contentInner}
      itemScope
      itemType='https://schema.org/CreativeWork'
    >
      {!!name && <h2 className={styles.title}>{name}</h2>}
      {videos.length > 0 && (
        <div
          className={styles.videoSlider}
          itemScope
          itemType='https://schema.org/VideoGallery'
        >
          <SliderWrapper
            className={classNames(styles.slider, { [styles.dark]: dark })}
            options={{
              autoplay: false,
              slidesToShow: 1,
              infinite: true,
              arrows: true,
              dots: false,
              nextArrow: <SlickArrow className={'slick-arrow slick-next'} />,
              prevArrow: <SlickArrow className={'slick-arrow slick-prev'} />,
              responsive: null,
            }}
          >
            {videos.map((video, key) => (
              <Video
                video={video}
                className={styles.video}
                icon={<PlayEmpty />}
                key={key}
              />
            ))}
          </SliderWrapper>
        </div>
      )}
      {/* {!!steps.length && (
        <div className={styles.videoSlider}>
          <div className={`${styles.steps} grid-extend`}>
            {steps.map(renderStep)}
          </div>
        </div>
      )}
      {!!text && (
        <div
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )} */}
    </div>
  );
};

export default ContentBlock;
